
import PxoHiddenRowsModal           from './PxoHiddenRowsModal.js';
import { useEffect, useState }      from 'react';
import { usePxoPage }               from '../../contexts/PxoPageContext.js';
import api                          from '../../services/api.js';

export default function PxoHiddenRowsModalContainer () {

    const [hiddenRowsData,  setHiddenRowsData   ] = useState(null);
    const [_loading,        _isLoading          ] = useState(false);

    const { 
        isPxoHiddenRowsModalOpen, 
        setPxoHiddenRowsModalOpen, 
        pxoId 
    } = usePxoPage()

    const fecthHiddenRowsData = async () => {
        try {

            if (!pxoId) return

            const response = await api.get(`getPxoTableLines/${pxoId}`);
            console.log(response.data.slice(0, 3))
            setHiddenRowsData(response.data);
        
        } catch (error) {
            console.error(error);
        }
    };
  
    const handleCloseModal = () => {

        setPxoHiddenRowsModalOpen(false)  
        setHiddenRowsData(null) 
        
    };

    const handleChangeCheckBox = (pxoTableRowId) => {
        setHiddenRowsData(prevData => {
            return prevData.map(item => {
                if (item.id === pxoTableRowId) {
                    return { ...item, isHidden: !item.isHidden };
                }
                return item;
            });
        })
    }

    const handleSubmitNewData = async () => {
        _isLoading(true)
        try {

            const response = await api.put(`updatePxoTableLines/`, {pxoTableLines: hiddenRowsData, pxoId});
            console.log(response.data)
            _isLoading(false)
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(()=>{

        if (isPxoHiddenRowsModalOpen) fecthHiddenRowsData()

    }, [isPxoHiddenRowsModalOpen]);


    return (

        <PxoHiddenRowsModal

            isModalOpen={isPxoHiddenRowsModalOpen}
            closeModal={handleCloseModal}
            content={hiddenRowsData}
            handleChangeCheckBox={handleChangeCheckBox}
            handleSubmit={handleSubmitNewData}
            isLoading={_loading}

        />
        
    )

}















